module.exports = require("core-js/modules/esnext.aggregate-error.js");